import { render, staticRenderFns } from "./personalList.vue?vue&type=template&id=73e9b1c8"
import script from "./personalList.vue?vue&type=script&lang=js"
export * from "./personalList.vue?vue&type=script&lang=js"
import style0 from "./personalList.vue?vue&type=style&index=0&id=73e9b1c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports